// Last remaining placeholder: the 404 fallback. Every other monitoring page is now real.

import { LayoutDashboard } from 'lucide-react';
import { EmptyState } from '../components/EmptyState.js';

function Page({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <div className="mx-auto max-w-6xl">
      <h1 className="mb-4 font-heading text-2xl font-bold">{title}</h1>
      {children}
    </div>
  );
}

export function NotFound() {
  return (
    <Page title="Page not found">
      <EmptyState
        icon={LayoutDashboard}
        title="That page doesn't exist"
        description="Use the sidebar to navigate. If you think this is a broken link, let us know."
      />
    </Page>
  );
}
